import axios from 'axios';
import config from '../config/config';
import {
    PROFILE_USER_REQUEST,
    PROFILE_USER_RECEIVE,
    PROFILE_USER_CHANGE_VALUE,
    PROFILE_USER_SEND_SAVE,
    PROFILE_USER_RECEIVE_SAVE,
    PROFILE_USER_RECEIVE_SAVE_ERROR,
    PROFILE_USER_EDIT,
    AUTHORIZATION_CHANGE_USERNAME
} from '../config/actions';

export function getUser() {
    return dispatch => {
        dispatch({
            type: PROFILE_USER_REQUEST
        });
        axios(config.server.endpoint + 'backend/user/', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: PROFILE_USER_RECEIVE,
                    data: response.data
                });
            }
        })
    }
}

export function changeValue(name, value) {
    return {
        type: PROFILE_USER_CHANGE_VALUE,
        name,
        value
    }
}

export function editUser() {
    return {
        type: PROFILE_USER_EDIT
    }
}

export function saveUser(data) {
    return dispatch => {
        dispatch({
            type: PROFILE_USER_SEND_SAVE
        });
        axios(config.server.endpoint + 'backend/user/', {
            method: 'put',
            data: {
                username: data.username,
                changePassword: data.changePassword,
                oldPassword: data.oldPassword,
                newPassword1: data.newPassword1,
                newPassword2: data.newPassword2
            }
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    dispatch({
                        type: AUTHORIZATION_CHANGE_USERNAME,
                        username: data.username
                    });
                    dispatch({
                        type: PROFILE_USER_RECEIVE_SAVE,
                        data: response.data
                    });
                } else {
                    dispatch({
                        type: PROFILE_USER_RECEIVE_SAVE_ERROR,
                        data: response.data
                    });
                }
            }
        });
    }
}